import React, { useState, useEffect } from "react";
import axios from "axios";
import Apiurl from "../Apiurl";

export default function Staffoptionwithid(prop) {
  const apiurl = Apiurl();
  const [data, setdata] = useState([]);
  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${apiurl}staffdetails/?Role=${prop}&Status=&Staffid=`
      );

      const convertedarray = response.data.map((item, index) => ({
        value: item.Name + "-" + item.Staffid,
        label: item.Name + "-" + item.Staffid,
      }));
      setdata(convertedarray);
      console.log(convertedarray);
    } catch (error) {
      console.warn("Error fetching data:", error);
      alert(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  return data;
}
